import { render, staticRenderFns } from "./Gallery4.vue?vue&type=template&id=48eff9fe&scoped=true&"
import script from "./Gallery4.vue?vue&type=script&lang=js&"
export * from "./Gallery4.vue?vue&type=script&lang=js&"
import style0 from "./Gallery4.vue?vue&type=style&index=0&id=48eff9fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eff9fe",
  null
  
)

export default component.exports